/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */

export const INTEREST_FIELDS = [
  { key: 'Interests', formName: 'interest_Interests', type: 'tags' as const, span: 2, placeholder: 'Type to add interests' },
  { key: 'Games', formName: 'interest_Games', type: 'tags' as const, span: 2, placeholder: 'Type to add games' },
  { key: 'Tools', formName: 'interest_Tools', type: 'tags' as const, span: 2, placeholder: 'Type to add tools' },
  { key: 'Skills', formName: 'interest_Skills', type: 'tags' as const, span: 2, placeholder: 'Type to add skills' },
  { key: 'Computer(s)', formName: 'interest_ComputerSystem', type: 'select' as const, span: 1, placeholder: 'Select your OS', options: ['Windows', 'macOS', 'Linux', 'ChromeOS'] },
  { key: 'Phone(s)', formName: 'interest_PhoneSystem', type: 'select' as const, span: 1, placeholder: 'Select your phone OS', options: ['iOS', 'Android', 'Other'] },
  { key: 'Food', formName: 'interest_Food', type: 'tags' as const, span: 1, placeholder: 'Type to add food' },
  { key: 'Music', formName: 'interest_Music', type: 'tags' as const, span: 1, placeholder: 'Type to add music genres' },
  { key: 'Color', formName: 'interest_Color', type: 'tags' as const, span: 1, placeholder: 'Type to add colors' },
  { key: 'Movies and TV Shows', formName: 'interest_MoviesTV', type: 'tags' as const, span: 1, placeholder: 'Type to add movies and TV shows' },
  { key: 'Fun facts about me', formName: 'interest_FunFacts', type: 'text' as const, span: 2, placeholder: 'Tell us something fun about yourself' },
  { key: 'Favorite quote', formName: 'interest_FavoriteQuote', type: 'text' as const, span: 2, placeholder: 'What is your favorite quote?' },
];

const INTEREST_FIELD_KEYS = new Set(INTEREST_FIELDS.map((f) => f.key));

export const parseInterestsToFormFields = (interests: any[]): Record<string, any> => {
  const result: Record<string, any> = {};
  const newFormatEntries = (interests || []).filter((i: any) => INTEREST_FIELD_KEYS.has(i.name));
  const legacyEntries = (interests || []).filter((i: any) => !INTEREST_FIELD_KEYS.has(i.name));
  const lookup = new Map(newFormatEntries.map((i: any) => [i.name, i]));

  for (const field of INTEREST_FIELDS) {
    const entry = lookup.get(field.key);
    if (field.type === 'tags') {
      let keywords = entry?.keywords || [];
      if (field.key === 'Interests') {
        keywords = [...keywords, ...legacyEntries.map((e: any) => e.name)];
      }
      result[field.formName] = keywords;
    } else if (field.type === 'text') {
      result[field.formName] = entry?.keywords?.[0] || '';
    } else if (field.type === 'select') {
      result[field.formName] = entry?.keywords || undefined;
    }
  }

  return result;
};

export const buildInterestsFromFormFields = (form: any): any[] => {
  const interests: any[] = [];
  for (const field of INTEREST_FIELDS) {
    const value = form.getFieldValue(field.formName);
    if (field.type === 'tags') {
      if (value && value.length > 0) {
        interests.push({ name: field.key, keywords: value });
      }
    } else if (field.type === 'text') {
      if (value && value.trim()) {
        interests.push({ name: field.key, keywords: [value.trim()] });
      }
    } else if (field.type === 'select') {
      if (value) {
        interests.push({ name: field.key, keywords: [...value] });
      }
    }
  }
  return interests;
};
